import _ from 'lodash'
import { Concept, ConceptActivation, ConceptStatusValidityInfo } from '@fusion-advantage/formlib'
import L1TitleText from '../l1/L1TitleText'

interface L3TitleNodeProps {
	title?: string
	concept: Concept|null
	activation: ConceptActivation|null,
	validity: ConceptStatusValidityInfo|null,
}

const L3TitleText = ({concept, activation, validity, title}: L3TitleNodeProps) => {
	return (
		<L1TitleText 
			title={title ?? concept?.title ?? ''} 
			disabled={activation === ConceptActivation.Disabled}
			validity={validity?.severity}
			validityMessage={concept ? validity?.message(concept) : ''}
		/>
	)
}

export default L3TitleText
